import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { isListValue, getListFirstValue, isTowerLocation } from 'utils/kbUtil';
import _ from 'lodash';
import * as selectors from 'app/selectors';

var AreaBox = class extends React.Component {render()
  {
    const {
      section,
      locationSection,
      location_id,
      menu,
      isTowerLoc } =
    this.props;
    let loc_url = location_id ? `/locations/${location_id}` : '';

    const childrenWithProps = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, { isTowerLoc });
    });

    return (
      <div
      className="kb-out-box clear-fix"
      style={location_id ? { paddingTop: 0 } : {}}>

        <div className="sub-nav-bar" style={{ minWidth: 1450 }}>
          <div style={{ position: 'relative' }}>
            <div className="sub-nav-list clear-fix">
              {menu.map((data, index) => {
                return (
                  <Link
                  key={index}
                  className={
                  isListValue(data.value, section) ||
                  location_id && isListValue(data.value, locationSection) ?
                  'active' :
                  ''}

                  to={`/admin${loc_url}/areas/${getListFirstValue(
                  data.value)
                  }`}>

                    {' '}
                    {data.name}{' '}
                  </Link>);

              })}
            </div>
          </div>
        </div>

        <div className="margin-top-lg">
          <div className="clear-fix" style={{ height: '100%' }}>
            <section className="kb-content-t">{childrenWithProps}</section>
          </div>
        </div>
      </div>);

  }};


function mapStateToProps(state, props) {
  const { user } = state;
  const { params } = props;
  let sections = props.location.pathname.split('/');
  let section = sections.length > 3 ? sections[3] : '';
  let locationSection = sections.length > 5 ? sections[5] : '';
  let location_id = params && params.id;
  let location = selectors.getLocation(state, location_id) || {};
  const isTowerLoc = isTowerLocation(location);

  const menu = [
  {
    name: '分区管理',
    value: ['desks/list', 'desks', 1] },

  {
    name: '预订记录',
    value: ['desk_reservation', 2] },

  {
    name: '优惠管理',
    value: ['areacoupon'] }];



  return {
    menu,
    section,
    locationSection,
    user,
    location_id,
    location,
    isTowerLoc };

}

// Map action creators dispatch to props
// So we can call this.props.<actionName>.request(<params>) directly
function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaBox);
